module.exports = __webpack_public_path__ + "static/img/video-play.7a02108.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/video-play.jpg
// module id = pbSJ
// module chunks = 4